module.exports = __webpack_public_path__ + "img/img08.f83fd984.png";